const chars = [
  { idx: 13, char: ':' },
  { idx: 11, char: ':' },
  { idx: 6, char: '-' },
  { idx: 4, char: '-' },
];

// This method insert a string into another. idx is the index where we want to insert the string.
const splice = (value: string, idx: number, str: string) =>
  value.slice(0, idx) + str + value.slice(idx);

// Format the odata format (20220510T120000Z) to json format (2022-05-10T12:00:00Z)
export function formatODataDate(value: string): string {
  if (value.length !== 15 && value.length !== 16) return value;

  let newValue = value;
  for (let i = 0; i < chars.length; i++) {
    const char = chars[i];
    newValue = splice(newValue, char.idx, char.char);
  }

  return newValue;
}
